<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'historico.index', params: { aluno_id: aluno_id } })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Histórico do Aluno
        </h1>
      </v-col>
    </v-row>
    <v-form>
      <v-row>
        <v-col class="py-0" cols="12">
          <e-label>Aluno</e-label>
          <v-text-field v-model="selectedStudent" label="Aluno" dense solo disabled />
        </v-col>

        <v-col class="py-0" col="12" lg="4">
          <e-label>Estabelecimento</e-label>
          <v-text-field v-model="estabelecimento" label="Estabelecimento" dense solo />
        </v-col>

        <v-col class="py-0" col="12" lg="4">
          <e-label>Cidade</e-label>
          <v-text-field v-model="cidade" label="Cidade" dense solo />
        </v-col>
        <v-col class="py-0" col="12" lg="4">
          <e-label>Ano de conclusão</e-label>
          <v-text-field v-model="ano" label="Ano" type="number" dense solo />
        </v-col>
        <v-col class="py-0" cols="12">
          <e-label>Etapa</e-label>
          <e-autocomplete
            label="Etapa"
            :items="seriesList"
            v-model="serie_id"
            :item-value="(item) => item.id"
            :item-text="(item) => item.descricao"
            dense
            solo
          />
        </v-col>
        <v-col class="py-0" col="4">
          <e-label>Componente Curricular</e-label>
          <e-autocomplete
            v-for="(disciplina, index) in disciplinas"
            :ref="`disciplina-${index}`"
            label="Componente Curricular"
            :key="index"
            :items="disciplinasList"
            v-model="disciplinas[index]"
            :item-value="(item) => item.id"
            :item-text="(item) => item.descricao"
            dense
            solo
            @keydown.native.tab.prevent="onTab($event, index, 'media')"
          />
        </v-col>
        <!-- <v-col class="py-0" cols="4">
          <e-label>Médias</e-label>
          <v-text-field
            v-for="(nota, index) in medias"
            :ref="`media-${index}`"
            :key="index"
            v-model="medias[index]"
            label="Média"
            dense
            solo
            v-mask="'##.#'"
            @blur="formatarMedia(index)"
            @keydown.tab="onTab($event, index, 'carga_horaria')"
          />
        </v-col> -->
        <v-col class="py-0" cols="3">
          <e-label>Médias</e-label>
          <v-currency-field
            v-for="(nota, index) in medias"
            :key="index"
            :ref="`media-${index}`"
            v-model="medias[index]"
            :value="value || null"
            :allow-negative="false"
            :min="min"
            :decimal-length="1"
            :max="max"
            label="Média"
            dense
            solo
            v-mask="'##.#'"
            @input="(val) => handleInput(val, index)"
            @keydown.tab="onTab($event, index, 'carga_horaria')"
          />
        </v-col>
        <v-col class="py-0" col="4">
          <e-label>Carga Horária</e-label>
          <v-text-field
            v-for="(cargahoraria, index) in carga_horaria"
            :ref="`carga_horaria-${index}`"
            :key="index"
            v-model="carga_horaria[index]"
            label="CH"
            v-mask="'###'"
            dense
            solo
            @keydown.tab="onTab($event, index, 'disciplina')"
          />
        </v-col>
        <v-col class="py-0" col="12" lg="2">
          <e-label>&nbsp;</e-label>
          <v-btn
            v-for="(nota, index) in disciplinas"
            :key="index"
            @click.prevent="removeField(index)"
            class="mb-7"
            color="error"
            type="submit"
            block
          >
            Excluir
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-7" cols="3">
          <v-btn @click.prevent="addField" color="primary" type="submit" block
            >Adicionar Componente Curricular <v-icon>mdi-plus</v-icon></v-btn
          >
        </v-col>
        <v-col class="py-0" cols="4">
          <e-label>Resultado</e-label>
          <e-autocomplete
            label="Resultado"
            :items="resultadoList"
            v-model="resultado"
            :item-value="(item) => item.id"
            :item-text="(item) => item.descricao"
            dense
            solo
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0" cols="12">
          <v-btn @click.prevent="submitForm" color="primary" type="submit" block>Salvar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </main-template>
</template>

<script>
import { $toast } from "vuetify-snackbar-toast";

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
  },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      id: "",
      aluno_id: "",
      selectedStudent: "",
      estabelecimento: "",
      cidade: "",
      ano: "",
      serie_id: null,
      disciplinas: [],
      disciplinasList: [],
      seriesList: [],
      resultadoList: this.$constants.situacaoHistorico,
      resultado: "",
      medias: [],
      carga_horaria: [],
      fraquiaAtual: "",
      turma: null,
      turmasList: [],
    };
  },
  methods: {
    async submitForm() {
      if (!this.formIsValidInputs()) {
        this.$loaderService.close();
        return;
      }
      const historico = {
        id: this.id,
        aluno_id: this.aluno_id,
        estabelecimento: this.estabelecimento,
        cidade: this.cidade,
        ano: this.ano,
        serie_id: this.serie_id,
        disciplinas: this.disciplinas,
        medias: this.medias,
        carga_horaria: this.carga_horaria,
        turma_id: this.turma,
        resultado: this.resultado,
      };
      try {
        this.$loaderService.open("Salvando dados");
        if (this.editing) {
          await this.$services.historicoService.atualizarHistorico(historico);
        } else {
          await this.$services.historicoService.criarHistorico(historico);
        }
        this.$router.push({ name: "historico.index", params: { aluno_id: this.aluno_id } });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    addField() {
      if (
        this.disciplinas[this.disciplinas.length - 1] !== " " &&
        this.medias[this.medias.length - 1] !== " " &&
        this.carga_horaria[this.carga_horaria.length - 1] !== " "
      ) {
        this.disciplinas.push(" ");
        this.medias.push(" ");
        this.carga_horaria.push(" ");
      } else {
        $toast.danger("É necessário preencher a anterior para cadastrar a pŕoxima");
      }
    },
    removeField(index) {
      if (this.disciplinas.length === 1) {
        $toast.danger(
          "É necessário deixar pelo menos um Componente Curricular e uma Carga horária"
        );
        return;
      }

      this.disciplinas.splice(index, 1);
      this.medias.splice(index, 1);
      this.carga_horaria.splice(index, 1);
    },

    formIsValidInputs() {
      const fields = [
        { value: this.selectedStudent, message: "O campo Aluno é obrigatório." },
        { value: this.estabelecimento, message: "O campo Estabelecimento é obrigatório." },
        { value: this.cidade, message: "O campo Cidade é obrigatório." },
        { value: this.ano, message: "O campo Ano de conclusão é obrigatório." },
      ];

      const arrayFields = [
        {
          value: this.disciplinas,
          message: "O campo Componente Curricular é obrigatório e não pode conter valores nulos.",
        },
        {
          value: this.medias,
          message: "O campo Médias é obrigatório e não pode conter valores nulos.",
        },
        {
          value: this.carga_horaria,
          message: "O campo Carga Horária é obrigatório e não pode conter valores nulos.",
        },
      ];

      // Verificando campos
      let isValid = true;
      fields.forEach((field) => {
        if (!field.value) {
          $toast.danger(field.message);
          isValid = false;
        }
      });

      // Verificando arrays
      arrayFields.forEach((field) => {
        if (!field.value || field.value.length === 0 || field.value.includes(null)) {
          $toast.danger(field.message);
          isValid = false;
        }
      });

      return isValid;
    },
    async loadData() {
      this.disciplinasList = await this.$services.disciplinasService.syncAll();
      this.seriesList = (await this.$services.seriesService.syncAll()).filter(
        (serie) => serie.historico === 1
      );
      if (this.editing) {
        const historico = await this.pegarHistorico();
        this.id = historico.id;
        this.selectedStudent = historico.aluno.nomecompleto;
        this.aluno_id = historico.aluno.id;
        this.estabelecimento = historico.estabelecimento;
        this.cidade = historico.cidade;
        this.ano = historico.ano;
        this.serie_id = parseInt(historico.serie_id, 10);
        this.disciplinas = historico.disciplinas;
        this.medias = historico.medias;
        this.carga_horaria = historico.carga_horaria;
        this.turma = historico.turma_id;
        this.resultado = historico.resultado;
      } else {
        const aluno = await this.$services.historicoService.pegarAluno(
          this.$router.currentRoute.params.aluno_id
        );
        this.selectedStudent = aluno.nomecompleto;
        // this.municipio = aluno.municipio_residencia;
        this.aluno_id = aluno.id;
        this.addField();
      }
      const turmasExternas = await this.$services.historicoService.pegarTurmasDoAluno(
        this.$router.currentRoute.params.aluno_id
      );

      this.turmasList = turmasExternas.map((turma) => ({
        id: turma.turma_id,
        descricao: `Turma: ${turma.turma.descricao} - Ano: ${turma.ano.descricao}`,
      }));
    },
    async pegarHistorico() {
      try {
        const { historico_id } = this.$route.params;
        const historico = await this.$services.historicoService.pegarHistorico(historico_id);
        return historico[0][0];
      } catch (error) {
        return this.$handleError(error);
      }
    },
    // formatarMedia(index) {
    //   let valor = this.medias[index];

    //   if (!valor) {
    //     this.$set(this.medias, index, null);
    //     return;
    //   }

    //   valor = parseFloat(valor.replace(',', '.'));

    //   // Limita entre 0 e 10
    //   if (isNaN(valor) || valor < 0) valor = 0;
    //   if (valor > 10) valor = 10;

    //   // Força uma casa decimal
    //   valor = valor.toFixed(1);

    //   this.$set(this.medias, index, valor);
    // },
    handleInput(val, index) {
      if (val > this.max) {
        this.$set(this.medias, index, this.max);
      } else if (val < this.min) {
        this.$set(this.medias, index, this.min);
      } else {
        this.$set(this.medias, index, parseFloat(val, 10));
        this.$emit("input", this.medias);
        this.$emit("change", this.medias);
      }
    },
    // Essa função é chamada para focar no proximo campo ao apertar 'tab' nos campos disciplinas, medias e carga horária.
    onTab(event, index, nextField) {
      event.preventDefault();
      if (nextField === "media") {
        this.$refs[`media-${index}`][0].$el.querySelector("input").focus();
      } else if (nextField === "carga_horaria") {
        this.$refs[`carga_horaria-${index}`][0].$el.querySelector("input").focus();
      } else if (nextField === "disciplina") {
        if (index + 1 < this.disciplinas.length) {
          this.$refs[`disciplina-${index + 1}`][0].$el.querySelector("input").focus();
        }
      }
    },
  },
};
</script>

<style></style>
